import React, { Dispatch, SetStateAction, useContext } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { axClient } from '../../../../axiosClient';
import { ToolBarContext } from '../../../../App';
import useVideoContext from '../../../../hooks/useVideoContext/useVideoContext';

interface recordModalProps {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  start: boolean;
  setStart: Dispatch<SetStateAction<boolean>>;
  startRecording: () => void;
  stopRecording: () => void;
  isOptionsOpened: boolean;
  setIsOptionsOpened: Dispatch<SetStateAction<boolean>>;
}

export default function RecordPermissionModal({
  showModal,
  setShowModal,
  start,
  setStart,
  startRecording,
  stopRecording,
  setIsOptionsOpened,
}: recordModalProps) {
  const { setSnackBar, setSnackBarText } = useContext(ToolBarContext);
  const action = start ? 'Start' : 'Stop';
  const snackBarAction = start ? 'started' : 'stopped';
  const { sendDataToParticipants, setIsRecording } = useVideoContext();

  const handleClose = () => {
    setShowModal(false);
  };

  const modalActions = () => {
    setShowModal(false);
    setStart(!start);
    setSnackBar(true);
    setSnackBarText(`Recording ${snackBarAction}`);
    setIsRecording(start);
    sendDataToParticipants(
      JSON.stringify({
        type: `RECORDING_${action.toUpperCase()}`,
        data: {
          is_recording: start,
        },
      })
    );
  };

  const handleaction = () => {
    const bodyParameters = {
      record_type: action.toUpperCase(),
    };
    axClient
      .post(`/?record_type=${action.toUpperCase()}`, bodyParameters)
      .then(() => {
        if (start) {
          startRecording();
          modalActions();
        } else {
          stopRecording();
          setIsOptionsOpened(true);
          modalActions();
        }
      })
      .catch(err => {
        throw err;
      });
  };

  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      aria-labelledby="permission-dialog-title"
      aria-describedby="permission-dialog-description"
      disableBackdropClick
    >
      <DialogTitle id="permission-dialog-title">{action} Recording</DialogTitle>
      <DialogContent>
        <DialogContentText id="permission-dialog-description">
          Are you sure want to {action} the recording of this session?
        </DialogContentText>
        {action === 'Start' ? (
          <DialogContentText>*Recording will be attached to the job notes once the call is completed</DialogContentText>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleaction} id="action">
          {action}
        </Button>
        <Button variant="contained" onClick={handleClose} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
